import moment from "moment/moment";

export const timestampToHumanReadable = (date) => {
  return moment(date).locale('pt-br').format('LLL')
}